import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { toHtmlElem, getAnchors, getParent } from "./dom";
export var getTargets = function getTargets(parent, selectors) {
  var line_1 = toHtmlElem(parent, selectors.line_1);
  if (line_1 === null) return null;
  var post_town = toHtmlElem(parent, selectors.post_town);
  if (post_town === null) return null;
  var postcode = parent.querySelector(selectors.postcode);
  if (postcode === null) return null;
  var line_2 = toHtmlElem(parent, selectors.line_2);
  var line_3 = toHtmlElem(parent, selectors.line_3);
  var country = toHtmlElem(parent, selectors.country);
  var county = toHtmlElem(parent, selectors.county);
  var organisation = toHtmlElem(parent, selectors.organisation);
  return {
    line_1: line_1,
    line_2: line_2,
    line_3: line_3,
    post_town: post_town,
    county: county,
    postcode: postcode,
    organisation: organisation,
    country: country
  };
};
export var relevantPage = function relevantPage(bindings) {
  return bindings.some(function (b) {
    return b.pageTest();
  });
};
export var defaults = {
  enabled: true,
  apiKey: "",
  populateOrganisation: true,
  populateCounty: false,
  autocomplete: true,
  autocompleteOverride: {},
  postcodeLookup: true,
  postcodeLookupOverride: {}
};
export var config = function config() {
  var c = window.idpcConfig;
  if (c === undefined) return;
  return _objectSpread(_objectSpread({}, defaults), c);
};
export var generateTimer = function generateTimer(_ref) {
  var pageTest = _ref.pageTest,
      bind = _ref.bind,
      _ref$interval = _ref.interval,
      interval = _ref$interval === void 0 ? 1000 : _ref$interval;
  var timer = null;

  var start = function start(config) {
    if (!pageTest()) return null;
    timer = window.setInterval(function () {
      try {
        bind(config);
      } catch (e) {
        stop();
        console.log(e);
      }
    }, interval);
    return timer;
  };

  var stop = function stop() {
    if (timer === null) return;
    window.clearInterval(timer);
    timer = null;
  };

  return {
    start: start,
    stop: stop
  };
};

var NOOP = function NOOP() {};

export var setup = function setup(_ref2) {
  var bindings = _ref2.bindings,
      _ref2$callback = _ref2.callback,
      callback = _ref2$callback === void 0 ? NOOP : _ref2$callback;
  var c = config();
  if (c === undefined) return callback();
  if (!relevantPage(bindings)) return callback();
  var result = bindings.reduce(function (prev, binding) {
    var pageTest = binding.pageTest,
        bind = binding.bind;
    if (!pageTest()) return prev;

    var _generateTimer = generateTimer({
      pageTest: pageTest,
      bind: bind
    }),
        start = _generateTimer.start,
        stop = _generateTimer.stop;

    start(c);
    prev.push({
      binding: binding,
      start: start,
      stop: stop
    });
    return prev;
  }, []);
  return callback(result);
};
var DEFAULT_SCOPE = "form";
var DEFAULT_ANCHOR = "line_1";
export var setupBind = function setupBind(_ref3) {
  var selectors = _ref3.selectors,
      anchorSelector = _ref3.anchorSelector,
      parentScope = _ref3.parentScope,
      doc = _ref3.doc,
      parentTest = _ref3.parentTest;
  var anchors = getAnchors(anchorSelector || selectors[DEFAULT_ANCHOR], doc);
  return anchors.reduce(function (prev, anchor) {
    var parent = getParent(anchor, parentScope || DEFAULT_SCOPE, parentTest);
    if (!parent) return prev;
    var targets = getTargets(parent, selectors);
    if (targets === null) return prev;
    prev.push({
      targets: targets,
      parent: parent,
      anchor: anchor
    });
    return prev;
  }, []);
};
export var toId = function toId(elem) {
  return "#".concat(elem.id);
};
export var cssEscape = function cssEscape(value) {
  value = String(value);
  var length = value.length;
  var index = -1;
  var codeUnit;
  var result = "";
  var firstCodeUnit = value.charCodeAt(0);

  while (++index < length) {
    codeUnit = value.charCodeAt(index);

    if (codeUnit == 0x0000) {
      result += "\uFFFD";
      continue;
    }

    if (codeUnit >= 0x0001 && codeUnit <= 0x001f || codeUnit == 0x007f || index == 0 && codeUnit >= 0x0030 && codeUnit <= 0x0039 || index == 1 && codeUnit >= 0x0030 && codeUnit <= 0x0039 && firstCodeUnit == 0x002d) {
      result += "\\" + codeUnit.toString(16) + " ";
      continue;
    }

    if (index == 0 && length == 1 && codeUnit == 0x002d) {
      result += "\\" + value.charAt(index);
      continue;
    }

    if (codeUnit >= 0x0080 || codeUnit == 0x002d || codeUnit == 0x005f || codeUnit >= 0x0030 && codeUnit <= 0x0039 || codeUnit >= 0x0041 && codeUnit <= 0x005a || codeUnit >= 0x0061 && codeUnit <= 0x007a) {
      result += value.charAt(index);
      continue;
    }

    result += "\\" + value.charAt(index);
  }

  return result;
};